import { useNavigate } from "react-router-dom";
import {
  getUserData,
  setSelectedSearchOrderType,
} from "../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import SchedularModal from "./SchedularModal";
import StatusFilterModal from "./StatusFilterModal";
import { useEffect, useRef, useState } from "react";
import { formatDate, localeDateEndDate, localeDateStartDate, maskMobileNumber } from "../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";

import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import TabMenu from "./TabMenu";
import StoreMenu from "./StoreMenu";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ButtonLink from "../ButtonLink";
import { whatsAppNotification } from "../services/StoreNotification/StoreNotification";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import useWhatsappNotification from "./StoreContext/useWhatsappNotification";

const { innerWidth: width, innerHeight: height } = window;

const WhatsappNotification = () => {
  const navigate = useNavigate();

  const { storeData, userProfileRole, brandProfileData } = getUserData();

  const storeId = storeData.id;
  let brandId = brandProfileData.id;
  const {
    sortingData,
    setSortingData,
    schedularDate,
    setSchedularDate,
    customerALLOrdersData,
    setCustomerALLOrdersData,
    page,
    setPage,
    searchTerm,
    setSearchTerm,
    useEffectCall,
    setUseEffectCall,
  } = useWhatsappNotification()

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  // const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  // const [page, setPage] = useState(0);
  // const [useEffectCall, setUseEffectCall] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchTermClean, setSearchTermClean] = useState(false);
  // const [searchTerm, setSearchTerm] = useState("");

  const initializeVariable = () => {
    setCustomerALLOrdersData([]);
  };
  
  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  // const [sortingData, setSortingData] = useState(false)

  const handleSortData = () => {
    setUseEffectCall(true);
    setPage(0);
    setSortingData(!sortingData);
  };

  // const [schedularDate, setSchedularDate] = useState({});
  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setUseEffectCall(true);
    setPage(0);
    setSchedularDate(newSchedular);
  };

  const handleClearSearch = () => {
    setUseEffectCall(true);
    setPage(0);
    setSearchTerm("");
    fetchNotification(data);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [isEndReached, setIsEndReached] = useState(false);
  const ds = useRef(null);

  const fetchNotification = (data) => {
    setLoading(true);
    whatsAppNotification({
      ...data,
      limit: 10,
      offset: page * 10, // Ensure offset is correctly applied
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          // if (page === 0) {
          //   setCustomerALLOrdersData(Res); // Reset state with new data
          // } else {
          //   setCustomerALLOrdersData((prevData) => [...prevData, ...Res]);
          // }
          if (page === 0) {
            setCustomerALLOrdersData(Res); // Reset with fresh data
          } else {
            setCustomerALLOrdersData((prevData) => {
              const existingIds = new Set(prevData.map((item) => item.id));
              const newUniqueData = Res.filter((item) => !existingIds.has(item.id));
              return [...prevData, ...newUniqueData];
            });
          }
          setLoading(false);
          setLoadingSearch(false);
          setSearchTermClean(false);
          setIsEndReached(Res.length < 10);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
        setLoadingSearch(false);
        setSearchTermClean(false);
      });
  };
  // for all status and one week data or by default data;
  const data = {
    storeIdIn: [storeId],
    brandId: brandId,
    startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
    sortOrder:"desc"
  };
  const [requestData, setRequestData] = useState(data);

  useEffect(() => {
    if (useEffectCall) {
      initializeVariable();
      requestData.startDate = schedularDate?.startDate
        ? localeDateStartDate(new Date(schedularDate.startDate))
        : localeDateStartDate(new Date(startDate));
      requestData.endDate = schedularDate?.endDate
        ? localeDateEndDate(new Date(schedularDate.endDate))
        : localeDateEndDate(new Date(endDate));
        requestData.sortOrder = sortingData ? "asc" : "desc";
      setPage(0);
      fetchNotification(requestData);
    }
  }, [schedularDate, sortingData ,searchTermClean]);

  useEffect(() => {
    fetchNotification(data);
  }, []);

  useEffect(() => {
    requestData.notifyTo = searchTerm;
    if (page > 0) fetchNotification(requestData);
  }, [page]);
 

  const resetFunctionCall = () => {
    requestData.startDate = schedularDate?.startDate
      ? localeDateStartDate(new Date(schedularDate.startDate))
      : localeDateStartDate(new Date(startDate));
    requestData.endDate = schedularDate?.endDate
      ? localeDateEndDate(new Date(schedularDate.endDate))
      : localeDateEndDate(new Date(endDate));
    requestData.sortOrder = sortingData ? "asc" : "desc";
    setPage(0);
    fetchNotification(requestData);
  };

  const searchTermApiCall = (text) => {
    if (text.length > 5) {
      setLoadingSearch(true);
      setPage(0);
      requestData.notifyTo = text;
      fetchNotification(requestData);
    } else if (text.length === 0) {
      resetFunctionCall();
    } else {
      setLoadingSearch(true);
      setUseEffectCall(true);
      setPage(0);
    }
  };

  const getData = () => {
    if (!isEndReached && !loading) {
      setPage((prevPage) => prevPage + 1);
      ds.current.load();
    }
  };
 
  const itemTemplate = (data) => {
    const formattedCreatedDate = formatDate(data.createdDate);

    return (
      <Accordion>
        <AccordionTab
          key={data.id} // Use a more unique key like data.id
          header={`${
            data?.orderBasicInfo?.invoiceNo || "N/A"}`}
        >
          <div
            className="cursor-pointer"
          >
            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Invoice No:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.orderBasicInfo?.invoiceNo || "N/A"}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Date:
                </p>
                <p className="text-lg font-bold capitalize">
                  {formattedCreatedDate}
                </p>
              </div>
            </div>

            <div className="flex-row">
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Customer Name:
                </p>
                <p className="text-lg font-bold capitalize">
                  {data?.orderBasicInfo?.customerName || "N/A"}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">
                  Customer Mobile No.:
                </p>
                <p className="text-lg font-bold capitalize">
                  {maskMobileNumber(data?.notifyTo) || "N/A"}
                </p>
              </div>
              <div className="col-4">
                <p className="text-base font-semiBold capitalize">Notification:</p>
                <p className="text-lg font-bold capitalize">
                  {data?.notification || "N/A"}
                </p>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    );
  };
 

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
      >
        <span>
          {rowData?.orderBasicInfo?.invoiceNo}
        </span>
      </div>
    );
  };

  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={customerALLOrdersData}
        // header={header}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "120rem" }}
        stripedRows
        scrollable
        scrollHeight={height - 220}
      >
      <Column
                header="S No."
                style={{ width: "80px" }}
                body={(rowData, options) =>
                  options.rowIndex + 1}
              ></Column>
        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{ width: "130px" }}
          body={invoiceBodyTemplate}
        ></Column>
        <Column
          field="createdDate"
          header="Date"
          style={{ width: "130px" }}
          body={(rowData) => formatDate(rowData?.createdDate)}
        />
        <Column
          field="customerName"
          header="Customer Name"
          style={{ width: "180px" }}
          body={(rowData) => rowData?.orderBasicInfo?.customerName?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="customerMobile"
          header="Mobile"
          style={{ width: "100px" }}
          body={(rowData) => maskMobileNumber(rowData?.notifyTo)}
        ></Column>
          
        <Column
          field="notifyResponseStatus"
          header="Status"
          body={(rowData) => rowData?.notifyResponseStatus}
        ></Column>
        <Column
          field="notification"
          header="Notification"
          body={(rowData) => rowData?.notification}
        ></Column>
      </DataTable>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                WhatsApp Notification
              </p>
            </div>
          </div>
          <div
            onClick={() => handleSortData()}
            className="mx-2 cursor-pointer flex align-items-center"
          >
            {!sortingData ? (
              <i
                className="pi  pi-sort-amount-up-alt"
                style={{ fontSize: "25px", marginRight: 10, color: "#fff" }}
              ></i>
            ) : (
              <i
                className="pi  pi-sort-amount-down"
                style={{ fontSize: "25px", marginRight: 10, color: "#fff" }}
              ></i>
            )}
          </div>
          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2">
      <div className=" my-2 mx-5 flex flex-1">
            <div className="flex-1">
              <IconField iconPosition="left" className="flex flex-1">
                <InputIcon className="pi pi-search text-xl"> </InputIcon>
                <InputText
                  placeholder={"Search By Mobile No."}
                  value={searchTerm}
                  keyboardType={"numeric"}
                  onChange={(e) => {
                    // const copyNumber = e.target.value.replace(
                    //   /^\+91\s*|\s+/g,
                    //   ""
                    // );
                    setSearchTerm(e.target.value);
                    searchTermApiCall(e.target.value);
                  }}
                  className="text-xl flex flex-1 py-1 px-5"
                  style={{ borderRadius: 30 }}
                />
              </IconField>
            </div>

            <div
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
              onClick={handleClearSearch}
            >
              <div>
                <p className="text-3xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            </div>
          </div>
        {loadingSearch || loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : customerALLOrdersData?.length > 0 ? (
          <div>
          <div>
          
            <div
              className="scroll-bar mb-2"
            >
            <div className="mx-4 report-table">
              <div className="tab-view-table">{RenderTabView()}</div>
            </div>
            </div>
          
          </div>
          <div style={{display:"none"}}>
              <DataScroller
                value={customerALLOrdersData}
                itemTemplate={itemTemplate}
                rows={customerALLOrdersData?.length + 100}
                inline
                ref={ds}
                scrollHeight={height - 250}
                loader
                // footer={footer}
              />
            </div>
            </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Notification Found</p>
          </div>
        )}

        <div
          className="flex justify-content-center fixed "
          style={{ bottom: 80, left: 20 }}
        >
          <Button
            type="text"
            icon="pi pi-plus"
            // label="More"
            onClick={getData} // Update this to trigger `getData`
          />
        </div>

        <TabMenu />

        <SchedularModal
          setSchedularModalVisible={setSchedularModalVisible}
          schedularModalVisible={schedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
        />
        <StoreMenu setVisible={setVisible} visible={visible} />
        <ButtonLink />
      </div>
    </div>
  );
};

export default WhatsappNotification;
